/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import {
  Annotation,
  AnnotationSettings,
  AnnotationSettingsTabType,
  CurrentSelectionResult,
  RevitInformation,
  TagsState,
} from 'libs/sysque/toolbelt/feature/src/lib/models/annotation-settings';
import { Observable } from 'rxjs';

export interface IAnnotationSettingsFacade {  
  getAnnotationSettings(): Observable<AnnotationSettings>;
  saveAnnotationSettings(annotationSettings: AnnotationSettings): void;
  getRevitInformation(): void;
  getRevitInformationFromStore(): Observable<RevitInformation>
  getRevitVersionFromLocalStorage(): string;
  getTagLocationPath(): Observable<string>;
  getFittingsTagLocationPath(): Observable<string>;
  isCurrentSelectionValid(): Observable<CurrentSelectionResult>;
  getCurrentSelectionResult(): Observable<CurrentSelectionResult>;
  applyData(selectedTab: AnnotationSettingsTabType): void;

  updateStorage(key: string, value: any): void;
  getConduitSettingsDataFromXml(): Annotation[];
  getCableTrayDataFromXml(): Annotation[];
  getActivePropertyByTagName(name: string, items: Annotation[]): boolean;
  getTagsStateFromStorageByTabName(tabName: string): TagsState;
  setDefaultSelectionToStorageByTabNameAndAnnotationName(
    currentXmlAnnotation: Annotation,
    tabName: string,
    annotationName: string,
    selectionName: string
  ): void;
  getTagDataFromXmlByTabNameAndAnnotationName(tabName: string, tagName: string): Annotation;
  getTagDataFromLocalStorageByTagName(tagName: string): Annotation;
  getOccurrencePropertyByName(name: string, data: Annotation): boolean;
  getPropertiesPropertyByName(name: string, data: Annotation): boolean;
  getDataToLoadByTabAndAnnonationName(tabName: string, annotationName: string, dataSelectionName: string): Annotation;

  setActiveValueToLocalStorageByTabNameAndTagName(tabName: string, tagName: string, value: string): void;
  setPlacementValueToStorage(dataObjName: string, value: string): void;
  setOffsetValueToStorage(dataObjName: string, label: string, value: number): void;
  setOccurrenceValueToStorage(dataObjName: string, value: string): void;
  setPropertiesValueToStorage(dataObjName: string, label: string, value: boolean): void;
  setIgnoreStraightsValueToStorage(dataObjName: string, value: number): void;
  setTagPathValueToStorage(dataObjName: string, value: string): void;
  setFittingTagPathValueToStorage(dataObjName: string, value: string): void;

  loadImageByTabAndState(tabName: string, tagState: TagsState, data: Annotation[]): void;
}

export const ANNOTATION_SETTINGS_FACADE_TOKEN = new InjectionToken<IAnnotationSettingsFacade>(
  'ANNOTATION_SETTINGS_FACADE_TOKEN'
);
